import { stdObject } from "../../../../data/types/stdObject";
import { writeCommButtons } from "../../commissions/writeCommButtons";

export const writeCommmReport = ({
  t,
  user,
  id,
  searchValues,
  responseReportData,
  openWindow,
  setMsg,
  setModalData,
  closeMsg,
  reverseComm,
}: stdObject) => {
  const tempItemsData = responseReportData.items.reduce(
    (acc: stdObject, curr: stdObject) => {
      if (!(curr.AGECOY in acc)) {
        acc[curr.AGECOY] = {
          name: curr.ANOCOY,
          list: responseReportData.items
            .filter((v: stdObject) => v.AGECOY === curr.AGECOY)
            .map((v: stdObject) => {
              const EST2COY = v.DOCCOY === "SEV" ? v.EST2SEV : v.EST2FAC;
              return {
                ...v,
                ACTIVE: v.PAGCOY === 0,
                DOCCOY2: t(`c.${v.DOCCOY}`),
                LINCOY2: v.LINCOY === 0 ? "" : v.LINCOY,
                CLICOY:
                  v.DOCCOY === "SEV"
                    ? `(${v.CLISEV}) ${v.NOMSEV}`
                    : `(${v.CLIFAC}) ${v.NOMFAC}`,
                NOMCOY: `(${v.ARTCOY}) ${v.NOMCOY}`,
                TOTCOY: v.CANCOY * v.PRECOY,
                COMMCOY: (v.PRECOY * v.PROCOY) / 100,
                COMMTOTCOY: v.CANCOY * ((v.PRECOY * v.PROCOY) / 100),
                EST2COY:
                  EST2COY === 2
                    ? t(`p.paid2`)
                    : EST2COY === 1
                      ? t(`p.partial`)
                      : t(`p.pending`),
                PAGCOY: v.PAGCOY > 0 ? v.PAGCOY : "",
              };
            }),
        };
      }
      return acc;
    },
    {},
  );
  const tempCommData = responseReportData.commissions.reduce(
    (acc: stdObject, curr: stdObject) => {
      if (!(curr.AGECOYP in acc)) {
        acc[curr.AGECOYP] = {
          name: curr.NOMCOYP,
          list: responseReportData.commissions
            .filter((v: stdObject) => v.AGECOYP === curr.AGECOYP)
            .map((v: stdObject) => {
              return {
                ...v,
                ...writeCommButtons({
                  t,
                  name: curr.NOMCOYP,
                  serie: user.CODSUC,
                  commission: v,
                  openWindow,
                  setMsg,
                  setModalData,
                  closeMsg,
                  reverseComm,
                }),
              };
            }),
        };
      }
      return acc;
    },
    {},
  );
  return {
    ...searchValues,
    [id]: {
      ...searchValues[id],
      results: {
        items: tempItemsData,
        commissions: tempCommData,
      },
    },
  };
};
